import React from 'react';
import { LinkButton } from '@atlaskit/button/new';
import { Stack, xcss } from '@atlaskit/primitives';
import { useIntl } from '@atlassian/jira-intl';
import { messages } from './messages';

export const FeedbackCollectorDescription = () => {
	const { formatMessage } = useIntl();

	return (
		<Stack xcss={feedbackCollectorDescriptionStyles}>
			<p>{formatMessage(messages.descriptionNonFinal)}</p>
			<p>
				{formatMessage(messages.learnMoreNonFinal, {
					link: (chunks: React.ReactNode[]) => (
						<LinkButton appearance="link" spacing="none" href="/">
							{chunks}
						</LinkButton>
					),
				})}
			</p>
		</Stack>
	);
};

const feedbackCollectorDescriptionStyles = xcss({
	marginBottom: 'space.300',
});
